export default __webpack_public_path__ + "static/media/icons8-info.65ebc1e2.svg";